import { moduleUnlicensed } from '@/libs/license'

export const PrintSuccess = (message: string) => {
    const toast = useToast()
    toast.add({ title: message, color: 'success', duration: 3000 })
}

/**
 * One refusal, said once.
 *
 * `description` is for a refusal that is really a LIST — the rooms a bulk action could
 * not write, grouped by why. It belongs under the summary rather than in N toasts of
 * its own: fifteen rooms refused for two reasons is two sentences, not fifteen, and a
 * stack of identical toasts is a thing people swipe away without reading. It is given
 * longer on screen because it is read rather than glanced at.
 */
export const PrintError = (message: string, description = '') => {
    // Nothing is said over the module notice. Every screen that was mid-load when the
    // API refused the module calls this with its own "could not load" line, and a
    // stack of them piling up on top of the one explanation reads as a portal falling
    // apart rather than a hotel that has not bought something.
    if (moduleUnlicensed.value) return

    const toast = useToast()
    toast.add({
        title:    message,
        description,
        color:    'error',
        duration: description ? 10000 : 5000,
    })
}
